import axiosInstance from "./axiosInstance";
export const fetchLedgers= async (params={}) => {
  try {
    const response = await axiosInstance.get(`/api/ledger/all_ledger`,{
        params:params
    });
    return {
      success: true,
      data: response?.data?.data,
      message: response?.data?.message || "successful",
    };
  } catch (error) {
    return {
      success: false,
      message:
        error.response?.data?.message ||
        error.response?.data?.error ||
        " failed. Please try again.",
      status: error.response?.status || 500,
    };
  }
};
export const fetchAddmoneyLedgers= async (params={}) => {
  try {
    const response = await axiosInstance.get(`/api/ledger/addmoney`,{
        params:params
    });
    return {
      success: true,
      data: response?.data?.data,
      message: response?.data?.message || "successful",
    };
  } catch (error) {
    return {
      success: false,
      message:
        error.response?.data?.message ||
        error.response?.data?.error ||
        " failed. Please try again.",
      status: error.response?.status || 500,
    };
  }
};
export const fetchDmtLedgers= async (params={}) => {
  try {
    const response = await axiosInstance.get(`/api/ledger/dmt`,{
        params:params
    });
    return {
      success: true,
      data: response?.data?.data,
      message: response?.data?.message || "successful",
    };
  } catch (error) {
    return {
      success: false,
      message:
        error.response?.data?.message ||
        error.response?.data?.error ||
        " failed. Please try again.",
      status: error.response?.status || 500,
    };
  }
};




export const fetchAepsLedgers= async (params={}) => {
  try {
    const response = await axiosInstance.get(`/api/ledger/aeps`,{
        params:params
    });
    return {
      success: true,
      data: response?.data?.data,
      message: response?.data?.message || "successful",
    };
  } catch (error) {
    return {
      success: false,
      message:
        error.response?.data?.message ||
        error.response?.data?.error ||
        " failed. Please try again.",
      status: error.response?.status || 500,
    };
  }
};